import { Button, CircularProgress, Dialog, DialogContent } from '@mui/material'
import React from 'react'

export default function ConfirmDialog({ open, setOpen, rows, handleSubmit, loadingSubmit }) {
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth='xl'
        >
            <DialogContent>
                <div class="d-flex row align-items-center mb-4">
                    <div class="col-12">
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#3364af',
                        }}>
                            รายการยืมวัสดุ {/* {{data?.header}} */}
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 table-responsive-sm ">
                        <table class="table table-borderless  ">
                            <thead>
                                <tr>
                                    <th class="text-center" >ที่</th>
                                    <th class="text-center">เอกสารที่อ้างถึง</th>
                                    <th class="text-center" >รายการ</th>
                                    <th class="text-center" >ปีงบประมาณ</th>
                                    <th class="text-center" >ประเภทเงิน</th>
                                    <th class="text-center" >เลขครุภัณฑ์</th>
                                    <th class="text-center" >ปริมาณ</th>
                                    <th class="text-center" >หน่วย</th>
                                    <th class="text-center" >กว้าง (เมตร) </th>
                                    <th class="text-center" >ยาว (เมตร)</th>
                                    <th class="text-center" >หนา (มิลลิเมตร)</th>
                                    <th class="text-center" >ราคา/หน่วย (บาท)</th>
                                    <th class="text-center" >สถานะ</th>
                                    <th class="text-center" >หมายเหตุ</th>
                                </tr>
                            </thead>
                            <tbody class="">
                                {rows?.map((item, i) => (
                                    <tr>
                                        <td class="text-center">{i + 1}.</td>
                                        <td class="text-center">{item?.RefNo || '-'}</td>
                                        <td class="text-center">{item?.ItemNo?.ItemName}</td>
                                        <td class="text-center">{item?.BudgetYear}</td>
                                        <td class="text-center">{item?.BudgetType}</td>
                                        <td class="text-center">{item?.Lot || '-'}</td>
                                        <td class="text-center">{item?.Qty}</td>
                                        <td class="text-center">{item?.UnitNo?.UnitName}</td>
                                        <td class="text-center">{item?.Width || '-'}</td>
                                        <td class="text-center">{item?.Length || '-'}</td>
                                        <td class="text-center">{item?.Thick || '-'}</td>
                                        <td class="text-center">{item?.CostPrice}</td>
                                        <td class="text-center">{item?.Status}</td>
                                        <td class="text-center">{item?.Remark || '-'}</td>
                                    </tr>))}
                            </tbody>
                        </table>
                    </div>


                </div>
                <div class="row mt-4">

                    <div class="col-12 text-end">
                        <Button onClick={() => setOpen(false)} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                        <Button disabled={loadingSubmit} onClick={() => handleSubmit()} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>{loadingSubmit ? <CircularProgress size={'24px'} color="inherit" /> : 'ยืนยันการทำรายการ'}</Button>

                    </div>
                </div >
            </DialogContent >
        </Dialog >
    )
}
